export var MINIMUM_IDEAL_CHARGE = 50; // .50 EUR using Smallest Currency Unit

export var REDIRECT_IDEAL_URL = '/purchase/pending';
export var MINIMUM_IDEAL_NAME_LENGTH = 3;